import React from "react";

const PRACertificate = () => {
  return (
    <div className="flex justify-center px-4 py-10 bg-white">
      <div className="w-full lg:w-[90%] max-w-6xl">
        {/* Heading */}
        <h2 className="text-3xl font-bold mb-3 text-gray-800">PRA Registration Certificate</h2>
        <h3 className="text-xl font-semibold mb-2 text-teal-700">
          Punjab Revenue Authority - Government of Punjab
        </h3>
        <p className="text-gray-700 mb-8">
          <strong>PACIFIC BUILDERS (PVT) LTD</strong> is officially registered with the Punjab Revenue Authority (PRA) for providing taxable construction services.
        </p>

        {/* PRA Certificate Image */}
        <div className="mb-8">
          <img
            src="/images/cer8.jpg"
            alt="PRA Certificate"
            className="w-full h-auto max-h-[500px] rounded-lg shadow-lg"
          />
        </div>
      </div>
    </div>
  );
};

export default PRACertificate;
